import { render, staticRenderFns } from "./index_new_pc.vue?vue&type=template&id=2865fc70&scoped=true"
import script from "./index_new_pc.vue?vue&type=script&lang=js"
export * from "./index_new_pc.vue?vue&type=script&lang=js"
import style0 from "./index_new_pc.vue?vue&type=style&index=0&id=2865fc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865fc70",
  null
  
)

export default component.exports